import React from 'react';
import { Box, Text, VStack, Center, Spinner } from '@chakra-ui/react';
import Chart from 'react-apexcharts';

const TeamWorkload = ({ data, loading }) => {

  const users = data?.teamWorkload || [];

  const series = [
    {
      name: 'Workload %',
      data: users.map(u => Number(u.percentage)),
    },
  ];

  const categories = users.map(u => u.username);

  if (loading) {
    return (
      <Center h="250px">
        <Spinner />
      </Center>
    );
  }

  if (!users.length) {
    return (
      <VStack align="stretch" spacing={2}>
        <Text fontSize="lg" fontWeight="semibold" mb={0}>
          Team Workload
        </Text>
        <Box
          bg="white"
          borderRadius="lg"
          p={6}
          boxShadow="sm"
          borderWidth="1px"
          borderColor="gray.200"
          h="310px"
        >
          <Center h="full">
            <Text color="gray.500">
              No data available
            </Text>
          </Center>
        </Box>
      </VStack>
    );
  }

  const options = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
      background: '#f6f6f7',
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 600,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 0,
        barHeight: '100%',
        width: '100%',
        backgroundBarColors: ['#F3F4F6'],
        backgroundBarOpacity: 1,
        backgroundBarRadius: 4,
        dataLabels: {
          position: 'top',
        },
      },
    },
    colors: ['#9F7AEA', '#FC8181', '#4FD1C5'],
    stroke: {
      show: true,
      width: 2,
      colors: ['#fff'],
    },
    dataLabels: {
      enabled: true,
      offsetX: -5,
      style: {
        fontSize: '10px',
        fontWeight: 600,
      },
      formatter: (val) => val.toFixed(2),
    },
    xaxis: {
      categories: categories,
      labels: {
        style: {
          fontSize: '11px',
          colors: '#9CA3AF',
        },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
      max: 100,
    },
    yaxis: {
      labels: {
        style: {
          fontSize: '12px',
          fontWeight: 600,
          colors: '#374151',
        },
      },
    },
    grid: {
      show: true,
      borderColor: '#E5E7EB',
      position: 'back',
      xaxis: { lines: { show: true } },
      yaxis: { lines: { show: false } },
      padding: { top: 0, right: 10, bottom: 0, left: 10 },
    },
    legend: {
      show: true,
      position: 'bottom',
      horizontalAlign: 'center',
      fontSize: '11px',
      fontWeight: 500,
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (value) => `${value.toFixed(2)}%`,
      },
    },
  };

  return (
    <VStack align="stretch" spacing={2}>
      <Text fontSize="lg" fontWeight="semibold" mb={0}>
        Team Workload
      </Text>

      <Box
        bg="white"
        borderRadius="lg"
        p={6}
        boxShadow="sm"
        borderWidth="1px"
        borderColor="gray.200"
        h="310px"
      >
        <Chart options={options} series={series} type="bar" height={260} />
      </Box>
    </VStack>
  );
};

export default TeamWorkload;